import { Fragment, type ReactNode } from 'react'

/** Match `<br>`, `<br/>`, `<br />`, or `<br class="...">` (any attributes). */
const BR_TAG = /<br\b[^>]*\/?>/gi

function brClassFromTag(tag: string): string | undefined {
  const match = /\bclass(?:Name)?\s*=\s*["']([^"']*)["']/i.exec(tag)
  const value = match?.[1]?.trim()
  return value || undefined
}

/** Renders plain text with CMS `<br>` tags as line breaks (keeps `class` on `<br>`). */
export function renderWithBr(text: string): ReactNode {
  const parts: string[] = []
  const brClasses: Array<string | undefined> = []
  let lastIndex = 0
  const re = new RegExp(BR_TAG.source, 'gi')
  let match: RegExpExecArray | null
  while ((match = re.exec(text)) !== null) {
    parts.push(text.slice(lastIndex, match.index))
    brClasses.push(brClassFromTag(match[0]))
    lastIndex = match.index + match[0].length
  }
  parts.push(text.slice(lastIndex))

  if (parts.length === 1) return text

  return parts.map((part, i) => (
    <Fragment key={i}>
      {i > 0 && <br className={brClasses[i - 1]} />}
      {part}
    </Fragment>
  ))
}
